import React, { Component } from 'react';

import Calendar from 'react-calendar';

import '../styles/assignments.css';

class AssignmentDashboard extends Component {

  render() {
    const date = this.props.date;

    return (
      <div className="scene-leading-box scene-leading-box-inset">
        <div className="dashboard-header">
          <p className="dashaboard-header__day">{date.getDate()}</p>
          <div>
            <p className="dashboard-header__day-name">{date.toLocaleDateString('en-US', {weekday: 'long'})}</p>
            <p className="dashboard-header__month-year">{date.toLocaleDateString('en-US', { month: 'long'})} {date.getFullYear()}</p>
          </div>
        </div>
        <Calendar 
          minDetail="month"
          onChange={(value) => this.props.onDateChange(value)}
          onActiveDateChange={this.props.onActiveDateChange}
          value={date} />
      </div>
    );
  }
}

export default AssignmentDashboard;


// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/AssignmentDashboard.js